(function () {
'use strict';

angular
    .module('surveyControllers')
    .directive('surveyQuestion', directive);

directive.$inject = ['$q'];

function directive($q) {
    return {
        scope: {
            question: '=',
            layoutRatio: '=?',
            toAddResponse: '&',
            toRemoveResponse: '&',
            questions: '='
        },
        restrict: 'AE',
        template: '<div ng-include="getTemplateUrl()"></div>',
        controller: ['$scope', 'growl', function ($scope, growl) {

            $scope.getTemplateUrl = function () {
                return '/app/Main/survey/surveyQuestion-' +
                        $scope.question.QuestionTypeCategoryCode + '-' +
                        $scope.question.QuestionTypeCategoryBehaviour + '.tpl.html';
            }

            $scope.showTooManyResponsesErrorAlert = function () {
                growl.addErrorMessage('<span class="gritter-title">Too Many Responses</span>' +
                                        '<span>' +
                                        'Question <strong>' + $scope.question.TitleEN + '</strong></span>' +
                                        ' has <strong>' + $scope.question.Responses.length + '</strong> responses.' +
                                        '</span>');

                throw 'Question "' + $scope.question.TitleEN + '" has ' + $scope.question.Responses.length  + ' responses.';
            };
        }],
        link: function (scope, element, attrs) {
            scope.layoutRatio = scope.layoutRatio ? scope.layoutRatio : {
                column: 'col-sm-12'
            };
        }
    };
}
})();
